import "./tab2.scss";
import * as React from "react";
import {useState} from "react";
import SettingCard, {ISettingCard} from "../../../../../ui/settingcard/settingcard";
import {RadioButton} from "../../../../../modals/types/radiobutton";
import DotIndicator from "../../../../../ui/dotindicator/dotindicator";
import RadioButtons from "../../../../../ui/radiobutton/radiobutton";
import AutoComplete from "../../../../../ui/autocomplete/autocomplete";
import {autoCompleteItem} from "../../../../../modals/types/autocomplete";
import HorizontalDivider from "../../../../../ui/horizontaldivider/horizontaldivider";
import {DropDownItem} from "../../../../../modals/types/dropdown";
import DropDown from "../../../../../ui/dropdown/dropdown";

const Tab2 = () => {
    const [activate, setActivate] = useState("setting0");
    const [showers, setShowers] = useState('A');
    const [showerDevices, setShowerDevices] = useState('E');
    const [geography, setGeography] = useState('A');
    const [date, setDate] = useState('A');
    const [showTime, setShowTime] = useState('A');
    const settingItems: ISettingCard[] = [
        {
            title: "تنظیمات هوشمند خودکار",
            body: "تنظیمات را تیجار برای شما انتخاب می کند.",
            id: 0,
            activate: activate,
            setActivate: setActivate
        },
        {
            title: "تنظیمات دستی جزییات",
            body: "تنظیمات را به صورت دستی انتخاب می کنید.",
            id: 1,
            activate: activate,
            setActivate: setActivate
        }
    ]
    const ISPDropDownItems: DropDownItem[] = [
        {label: "آسیاتک"}, {label: "صبانت"}
    ];
    const showersContent: RadioButton[] = [
        {label: "خودکار", currentValue: "A"},
        {label: "انتخاب از بین گروه", currentValue: "C"}
    ]
    const showerDevicesContent: RadioButton[] = [
        {label: "همه دستگاه‌ها", currentValue: "E"},
        {label: "موبایل Android", currentValue: "A"},
        {label: "موبایل IOS", currentValue: "I"},
        {label: "دسکتاپ", currentValue: "D"},
    ]
    const geographyContent: RadioButton[] = [
        {label: "همه کشورها", currentValue: "A"},
        {label: "ایران", currentValue: "I"}
    ]
    const dateContent: RadioButton[] = [
        {label: "همیشه", currentValue: "A"},
        {label: "انتخاب بازه تاریخ", currentValue: "C"}
    ]
    const showTimeContent: RadioButton[] = [
        {label: "هر زمان", currentValue: "A"},
        {label: "انتخاب ساعت و روز", currentValue: "C"}
    ]
    const settingContent: JSX.Element[] = [
        <>
            <div className="col-lg-6 col-md-8 col-12 mb-3">
                1
            </div>
        </>,
        <>
            <div className="col-12 mb-3">
                <div className="d-flex align-items-center mb-4">
                    <DotIndicator/>
                    <span style={{fontSize: '18px'}}>تنظیمات نمایش</span>
                </div>
                <h6 className="mb-3 pt-1 font-light">نمایش دهندگان</h6>
                <RadioButtons items={showersContent} value={showers} setValue={setShowers}/>
            </div>
            <div className="col-12 mb-3">
                <h6 className="mb-3 pt-1 font-light">دستگاه های نمایش دهنده</h6>
                <RadioButtons items={showerDevicesContent} value={showerDevices} setValue={setShowerDevices}/>
            </div>
            <div className="col-12 mb-3">
                <h6 className="mb-3 pt-1 font-light">محدوده جغرافیایی</h6>
                <RadioButtons items={geographyContent} value={geography} setValue={setGeography}/>
            </div>
            <div className="col-lg-6 col-md-6 col-12 mb-3">
                <label className={"mb-2"} htmlFor="">ارایه دهندگان اینترنتی</label>
                <DropDown items={ISPDropDownItems} placeHolder={"انتخاب کنید"}/>
            </div>
            <HorizontalDivider/>
            <div className="col-12 mb-3">
                <h6 className="mb-3 pt-1 font-light">تنظیمات تاریخ</h6>
                <RadioButtons items={dateContent} value={date} setValue={setDate}/>
            </div>
            <div className="col-12 mb-3">
                <h6 className="mb-3 pt-1 font-light">زمان نمایش</h6>
                <RadioButtons items={showTimeContent} value={showTime} setValue={setShowTime}/>
            </div>
            <HorizontalDivider/>
        </>,
    ]

    return (
        <div className="Tab2">
            <div className="row pt-3">
                {
                    settingItems.map((settingItem, index) => {
                        return (
                            <div className="col-lg-5 col-md-6 col-12 mb-2">
                                <SettingCard activate={activate} title={settingItem.title} body={settingItem.body}
                                             setActivate={setActivate} id={index}/>
                            </div>
                        );
                    })
                }
            </div>
            <div className="row mt-4">
                {settingContent[parseInt(activate.substring(7, 8))]}
            </div>
        </div>
    );
}

export default Tab2;